import * as React from "react";
import { DynamicFieldRenderer } from "../Interfaces/dynamicFieldRenderer";

export const dynamicFieldRenderer: DynamicFieldRenderer = (props) => {
  return <>{props.children}</>;
};
